import { useMemo } from "react";
import ComposableCard from "src/shared/components/data-display/composable-card/ComposableCard"
import { getCurrencyFormat } from "src/utils/string";
import { ResumenCorteTickets } from "../../Sections/ResumenTurno/interfaces/resumenCorteTickets";

const positive = (value?: number) => (value && value > 0 ? value : 0)
// TODO: 1 reconectar cards
export const Cards = ({ data, onLinkFajillas }: { data: ResumenCorteTickets["dashboard"]; onLinkFajillas: () => void }) => {
    const dataCards = useMemo(() => {
        return [
            {
                title: "Total del turno",
                number: getCurrencyFormat(data?.total_turno || 0),
                className: "cortes-screen__card-item-total",
            },
            {
                title: "Visa y mastercard",
                number: getCurrencyFormat(data?.visa_mastercard || 0),
                title2: "AMEX",
                number2: getCurrencyFormat(data?.amex || 0),
            },
            {
                title: "Tranferencias y depósitos",
                number: getCurrencyFormat(data?.depositos_transfer || 0),
            },
            {
                title: "Efectivo en caja",
                number: getCurrencyFormat(data?.efectivo_caja && data?.efectivo_caja > 0 ? data?.efectivo_caja : 0),
                effectitrack: getCurrencyFormat(
                    data?.disponible_retiro && data?.disponible_retiro > 0 ? data?.disponible_retiro : 0
                ),
            },
            {
                title: "Efectivo retirado",
                number: getCurrencyFormat(data?.total_fajillas || 0),
                link: data?.cantidad_fajillas > 0 ? "Ver detalle" : "",
                onLink: onLinkFajillas,
            },
            {
                title: "Consumo interno",
                number: getCurrencyFormat(data?.consumo_interno || 0),
                title2: "Easyrewards",
                number2: getCurrencyFormat(data?.easy_rewards || 0),
            },
            {
                title: "Gastos de caja",
                number: getCurrencyFormat(data?.gastos ? Number(data?.gastos) * -1 : 0),
                className: "cortes-screen__card-item-caja",
            },
        ]
    }, [data])
    dataCards

    return (
        <div className="cortes-screen__cards animante__select">
            <ComposableCard containerClassName="cortes-screen__card_fill">
                <ComposableCard.Value title="Total del turno" value={data?.total_turno || 0} />
                <ComposableCard.Value
                    title="Total de ingresos"
                    value={data?.total_ventas || 0}
                    tooltip={{
                        title: "Total de ingresos",
                        description: "Es la sumatoria del total del turno más anticipos válidos",
                    }}
                />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value title="Visa y Mastercard" value={data?.visa_mastercard || 0} />
                <ComposableCard.Value title="AMEX" value={data?.amex || 0} />
            </ComposableCard>

            <ComposableCard containerClassName="cortes-screen__card_fill">
                <ComposableCard.Value title="Efectivo en caja" value={positive(data?.efectivo_caja)} />
                <ComposableCard.Compact value={positive(data?.disponible_retiro)} description="Para retiro" />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value
                    title="Efectivo retirado"
                    value={data?.total_fajillas || 0}
                    variant="link"
                    onValueClick={onLinkFajillas}
                />
                <ComposableCard.Value title="Transfer/ Depósitos" value={data?.depositos_transfer || 0} />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value title="Consumo interno" value={data?.consumo_interno || 0} />
                <ComposableCard.Value title="Anticipos válidos" value={data?.anticipos_validos || 0} />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Value title="Easyrewards" value={data?.easy_rewards || 0} />
                <ComposableCard.Value title="Cortesías" value={data?.cortesia || 0} />
            </ComposableCard>

            <ComposableCard>
                <ComposableCard.Highlight title="Gastos de caja" value={Math.abs(Number(data?.gastos || 0))} />
            </ComposableCard>
        </div>
    )
}
